"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ResponsiveMenuItems_1 = __importDefault(require("../../components/ResponsiveMenuItems"));
ResponsiveMenuItems_1.default.getInstance();
